// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--NiXw3","container":"container--Pwaet","Small":"Small--WKWt8","Large":"Large--pBUnI","list":"list--oWeS3","fadeSlideUp":"fadeSlideUp--AKX_e"};